document.addEventListener('DOMContentLoaded', function() {
  const duration = 6 * 1000, // 6 seconds
    animationEnd = Date.now() + duration,
    defaults = { 
      startVelocity: 30, 
      spread: 360, 
      ticks: 60, 
      zIndex: 1000, // Increased z-index to ensure visibility
      shapes: ["heart"],
      colors: ["#8C2C8D", "#2DA6B3", "#C6B7C9", "#4D0459"],
    };

  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  const interval = setInterval(function() {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const particleCount = 50 * (timeLeft / duration);

    // Confetti from top
    confetti(
      Object.assign({}, defaults, {
        particleCount,
        scalar: 3,
        origin: { x: randomInRange(0, 1), y: 0 },
      })
    );

    // Confetti from left
    confetti(
      Object.assign({}, defaults, {
        particleCount,
        scalar: 3,
        origin: { x: 0, y: randomInRange(0, 0.5) },
      })
    );

    // Confetti from right
    confetti(
      Object.assign({}, defaults, {
        particleCount,
        scalar: 3,
        origin: { x: 1, y: randomInRange(0, 0.5) },
      })
    );
  }, 250);
});
